import { createActionGroup, props } from '@ngrx/store';
import { BaseFapList } from '@api/backend';
import { ErrorResponse } from '@core/models';

export const searchActions = createActionGroup({
  source: 'Search',
  events: {
    'Load Faps': props<{ p?: number, ps?: number, q?: string, defaultList?: boolean }>(),
    'Load Faps Success': props<{ data: BaseFapList }>(),
    'Load Faps Failure': props<{ error: ErrorResponse }>(),
  },
});
